import { Link } from 'react-router';
import AsciiArt from '../components/AsciiArt';
import useDocumentMeta from '../hooks/useDocumentMeta';
import { asciiNotFound } from '../data/asciiNotFound';
import { navigation, notFoundMeta } from '../data/site';
import styles from './NotFound.module.scss';

function NotFound() {
  useDocumentMeta(notFoundMeta);

  return (
    <div className={styles.wrapper}>
      <AsciiArt grid={asciiNotFound} label="404" className={styles.mark} />

      <h1 className={styles.title}>This page does not exist</h1>
      <p className={styles.body}>
        The link may be out of date, or the address may have a typo in it. Try one of these
        instead:
      </p>

      <nav aria-label="Page not found">
        <ul className={styles.links}>
          {navigation.map(({ label, to }) => (
            <li key={to}>
              <Link to={to} className={styles.link}>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default NotFound;
